import React from 'react';
import styled from 'styled-components';
import Button from 'antd/es/button';

import colors from 'config/colors';
import Icon from './Icon';

const StyledButton = styled(Button)`
  color: ${props => props.color ? colors.get(props.color) || props.color : null};
  background-color: ${props => props.bgColor ? colors.get(props.bgColor) || props.bgColor : null};
`;

export default React.forwardRef((props, ref) => {
  const { icon, children, ...extra } = props;
  let iconEl = null;

  if (typeof icon === 'string') {
    iconEl = <Icon name={icon} size={16} />
  } else if (typeof icon === 'object') {
    if (React.isValidElement(icon)) {
      iconEl = icon;
    } else {
      iconEl = <Icon {...icon} />
    }
  }

  return (
    <StyledButton icon={iconEl} {...extra} ref={ref}>
      {children}
    </StyledButton>
  );
});
